import BellIcon from '@/components/Icons/BellIcon';
import {getContent} from '@/services/content/content';

interface TipNotificationCountButtonProps {
    count: number;
    expanded: boolean;
    controlsId: string;
    onClick: () => void;
}

const TipNotificationCountButton = ({count, expanded, controlsId, onClick}: TipNotificationCountButtonProps) => {
    const {tipsTitle} = getContent().experienceScoreContent ?? {};

    return (
        <button
            type='button'
            aria-label={tipsTitle && `${tipsTitle}: ${count}`}
            aria-expanded={expanded}
            aria-controls={controlsId}
            onClick={onClick}
            className='flex w-6 cursor-pointer flex-col items-center rounded-md bg-primary p-1 text-romance focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-2 dark:focus-visible:outline-romance'
        >
            <BellIcon className='size-4' />
            <span className='text-12 text-secondary leading-5 tracking-h5'>{count}</span>
        </button>
    );
};

export default TipNotificationCountButton;
